import {
    INIT_SESSION,
    DESTROY_SESSION,
    SELECT_PROPERTY,
    CHANGE_LOCALE,
    SET_PREFERENCES,
    SET_CONFIG,
    SET_AUTHORISED_PROPERTIES,
    SET_PROPERTY_EXTRA_INFO,
} from './constants';

export const initialState = null;

function appReducer(state = initialState, action) {
    if (action.type === INIT_SESSION) return action.session;
    if (action.type === DESTROY_SESSION) return initialState;
    if (state === null) return state;

    switch (action.type) {
        case SELECT_PROPERTY:
            return {
                ...state,
                selectedProperty: action.propertyId,
            };
        case CHANGE_LOCALE:
            return {
                ...state,
                userInfo: {
                    ...state.userInfo,
                    locale: action.locale,
                },
            };
        case SET_PREFERENCES:
            return {
                ...state,
                preferences: {
                    ...state.preferences,
                    ...action.preferences,
                },
            };
        case SET_CONFIG:
            return {
                ...state,
                config: {
                    ...state.config,
                    ...action.config,
                },
            };
        case SET_AUTHORISED_PROPERTIES:
            return {
                ...state,
                authorisedProperties: {
                    ...state.authorisedProperties,
                    ...action.authorisedProperties,
                },
            };
        case SET_PROPERTY_EXTRA_INFO:
            return {
                ...state,
                authorisedProperties: {
                    ...state.authorisedProperties,
                    ...action.authorisedProperties,
                },
            };
        default:
            return state;
    }
}

export default appReducer;
